import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-vh-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3 sc-fix-gap" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_notifications = _resolveComponent("app-notifications")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_notifications),
    _createVNode(_component_app_header),
    _hoisted_2,
    _createVNode(_component_router_view),
    _createVNode(_component_app_footer)
  ]))
}